import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const MenuIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6" aria-hidden="true">
    <path
      d="M4 7h16M4 12h16M4 17h16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6" aria-hidden="true">
    <path
      d="M6 6l12 12M18 6 6 18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const navLinks = [
  {
    title: "About",
    path: "/about",
  },
  {
    title: "⁠The Book",
    path: "/the-book",
  },
  {
    title: "The App",
    path: "/the-app",
  },
  {
    title: "The Podcast",
    path: "/the-podcast",
  },
  {
    title: "Recipes & Lifestyle",
    path: "recipes-and-lifestyle",
  },
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "auto";
  }, [mobileOpen]);

  return (
    <header className="header_wrapper_ border-b border-gray-300">
      <div className="relative z-50 page-width">
        <div className="flex items-center justify-between py-3">
          {/* Mobile menu toggle */}
          <button
            className="md:hidden"
            onClick={() => setMobileOpen(true)}
            aria-label="Open menu"
          >
            <MenuIcon />
          </button>

          {/* Logo */}
          <div className="flex-1 text-center md:text-left">
            <Link to="/" aria-label="The Plant Based Switch">
              <img
                src="/Images/logo.png"
                alt="The Plant Based Switch"
                width="180"
                height="132"
                className="mx-auto md:mx-0 logo__"
                decoding="async"
              />
            </Link>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="font-medium main_item_nav"
              >
                {link.title}
              </Link>
            ))}
          </nav>
        </div>

        {/* Backdrop */}
        {mobileOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-30 z-40"
            onClick={() => setMobileOpen(false)}
          />
        )}

        {/* Mobile Drawer */}
        <div
          className={`fixed top-0 left-0 w-72 h-full header_drawer_ z-50 shadow-md transition-transform duration-300 ease-in-out transform ${
            mobileOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
            <Link to="/" onClick={() => setMobileOpen(false)} aria-label="The Plant Based Switch">
              <img
                src="/Images/logo.png"
                alt="The Plant Based Switch"
                width="180"
                height="132"
                className="h-10 w-auto drawerLogo"
                decoding="async"
              />
            </Link>
            <button onClick={() => setMobileOpen(false)} aria-label="Close menu">
              <CloseIcon />
            </button>
          </div>

          <div className="px-4 pt-4 pb-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="block py-2"
                onClick={() => setMobileOpen(false)}
              >
                {link.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
